<template>
  <div class="page">
    <Header />
    <HeaderNav />
    <keep-alive :include="keepInclude">
      <router-view />
    </keep-alive>
    <Footer />
  </div>
</template>

<script>
import Header from './components/header'
import HeaderNav from './components/header-nav'
import Footer from './components/footer'
export default {
  components: {
    Header,
    HeaderNav,
    Footer
  },
  data () {
    return {
      keepInclude: [
        'MenuList',
        'PrintingList',
        'stock',
        'stock-quota',
        'stock-logitics',
        'stock-quota-out',
        'stock-apply',
        'stock-money',
        'stock-money-order',
        'stock-approve',
        'stock-apply-order',
        'group-list'
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.page {
  min-height: 100%;
}
</style>
